// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@bg/XDL/Helpers";
import Cancel from "@bg/XDL/Icons/Cancel";
import CheckCircle from "@bg/XDL/Icons/CheckCircle";
import Info from "@bg/XDL/Icons/Info";
import ReportProblem from "@bg/XDL/Icons/ReportProblem";
import colors from "@bg/XDL/PreStyle/colors";
import { xBaseTheme } from "@bg/XDL/types";
import ToastPresentationPropsDefault, {
    toasterProps as toasterPropsDefault,
} from "@insite/mobius/Toast/presentationProps";
import { get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

const iconColor = get(colors, "common.ui1");

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        cssOverrides: {
            toast: css`
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                border: none;
                border-top: ${({ messageType, theme }: any) => `4px solid ${resolveColor(messageType, theme)}`};
                background: ${getColor("common.ui8")};
                box-shadow: 0 0 25px 0 rgba(79, 79, 119, 0.18);
                @media print {
                    display: none;
                }
                ${screen("lte", "sm")`
                    max-width: 90%;
                    right: 20px;
                `}
            `,
            toastBody: css`
                &&& {
                    margin: 12px 10px;
                    &,
                    * {
                        font-size: 13px;
                        line-height: 15px;
                    }
                    max-height: 500px;
                    align-items: flex-start;
                }
            `,
        },
        iconProps: {
            size: 20,
            css: css`
                margin: auto 12px auto 0;
                width: 20px;
                height: 20px;
            `,
        },
        bodyTypographyProps: {},
        closeButtonProps: {
            color: "transparent",
            css: css`
                &,
                button {
                    background: transparent !important;
                    border: 0 !important;
                    box-shadow: none !important;
                }

                padding-left: 5px;
                padding-right: 5px;
                margin-right: 2px;
                margin-top: 0;
            `,
        },
        closeButtonIconProps: {
            color: iconColor,
            css: css`
                width: 20px;
                height: 20px;
            `,
        },
        iconSrcByMessage: {
            success: CheckCircle,
            danger: Cancel,
            warning: ReportProblem,
            info: Info,
        },
    },
    toasterProps: { toasterPropsDefault },
} as xBaseTheme["toast"];
